import React from "react";
import logo from "../assets/logo.png";
import Login from "../LoginRet/components/login/Login";
import { useState } from "react";
import "./header.css";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import ReactDOM from "react-dom";
import ProfileModal from "react-modal";
import UdateProfilModal from "react-modal";
import logobaru from "../assets/realv.png";

const Header = () => {
  const { name, email } = useSelector(state => state.login);
  const [showModal, setShowmodal] = useState(false);
  const [showModalProfile, setShowModalProfile] = useState(false);
  const [modalUpdate, setModalUpdate] = useState(false);
  const [nameUpdate, setNameUpdate] = useState();
  const [emailUpdate, setEmailUpdate] = useState();
  console.log(nameUpdate);
  console.log(emailUpdate);
  console.log(showModal);

  const customStyles = {
    overlay: {
      backgroundColor: "rgba(0,0,0,0)",
    },
    content: {
      top: "13%",
      left: "90%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      padding: "0",
      width: "10vw",
    },
  };

  const modalUpdateStyles = {
    overlay: {
      backgroundColor: "rgba(0,0,0,0)",
      height: "100vh",
      width: "100vw",
    },
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      textAlign: "center",
      width: "20vw",
    },
  };
  const handleCloseModalUpdate = () => {
    setModalUpdate(!modalUpdate);
  };

  const handleShowModalProfile = () => {
    setNameUpdate(name);
    setEmailUpdate(email);
    setModalUpdate(!modalUpdate);
  };
  const logout = () => {
    const store = window.localStorage;
    store.clear();
    window.location.reload();
  };

  return (
    <>
      {showModal && <Login set={setShowmodal} />}
      <div className="header">
        <Link className="header-link" to={`/`}>
          <div className="logo-wrapper">
            <img className="logo" src={logobaru} alt="logo" />
            {/* <h4>MilanTV</h4> */}
          </div>
        </Link>
        <input
          className="input-search"
          type="text"
          placeholder="Search Movie"
        />
        <button
          className="signin-btn"
          onClick={
            name == null
              ? () => setShowmodal(!showModal)
              : () => setShowModalProfile(!showModalProfile)
          }
        >
          {name != null ? name : "Sign In"}
          <ProfileModal
            isOpen={showModalProfile}
            onRequestClose={showModalProfile}
            shouldCloseOnOverlayClick={true}
            style={customStyles}
          >
            <div className="profile-btn" onClick={handleShowModalProfile}>
              Profile
            </div>
            <div className="profile-btn">Help</div>
            <div className="profile-btn">Setting</div>
            <div className="profile-btn" onClick={logout}>
              Sign Out
            </div>
          </ProfileModal>
        </button>
        <UdateProfilModal
          isOpen={modalUpdate}
          onRequestClose={handleCloseModalUpdate}
          style={modalUpdateStyles}
        >
          <h3
            style={{
              marginBottom: "20px",
              paddingBottom: "5px",
              borderBottom: "1px solid grey",
            }}
          >
            Profile
          </h3>
          <form className="form-update">
            <input
              type="text"
              value={nameUpdate}
              onChange={e => setNameUpdate(e.target.value)}
            ></input>
            <input
              type="text"
              value={emailUpdate}
              onChange={e => setEmailUpdate(e.target.value)}
            ></input>
            <button type="submit">Update Profile</button>
          </form>
        </UdateProfilModal>
      </div>
    </>
  );
};

export default Header;
